import { useEffect, useState } from "react";
import { deleteAdmin } from "../../services/adminApi";
import { TbFileDownload } from "react-icons/tb";
import { MdVerifiedUser, MdDoNotDisturbOn, MdDelete } from "react-icons/md";
import { BiSolidUserCheck, BiSolidUserX } from "react-icons/bi";
import { toast } from "react-toastify";
import { Pagination, Spinner } from "react-bootstrap"; // Import Bootstrap Pagination component
import instance  from "../../services/endpoint"
import Loader from "../utilComponents/loader";
import ShimmerLoader from "../utilComponents/shimmer";
import { useAllAdmins } from "../../services/hooks/getSuperAdminApis";
import "../../styles/AllAdmins.css";

const AllAdmins = ({ searchQuery }) => {
  const [admins, setAdmins] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // Track current page
  const itemsPerPage = 5; // Items per page
  const [selectedUser, setSelectedUser] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [lastVerifiedAdminID, setLastVerifiedAdminID] = useState(null);
  const [adminVerifyLoading, setAdminVerifyLoading] = useState(false);


  // fetch all admins using custom hook
  const { data: allAdmins, isLoading } = useAllAdmins();

  useEffect(() => {
    if (allAdmins && Array.isArray(allAdmins)) {
      setAdmins(allAdmins.reverse());
    }
  }, [allAdmins]);



  //  **Filter requests based on searchQuery**
  const filteredRequests = admins.filter((request) => {
    const searchLower = searchQuery.toLowerCase();
    const isVerified = request.isEmailVerified ? "verified" : "not checked";

    return (
      request.AdminID.toLowerCase().includes(searchLower) ||
      request.Email.toLowerCase().includes(searchLower) ||
      request.FullName.toLowerCase().includes(searchLower) ||
      isVerified.includes(searchLower) ||
      (searchLower === "verified" && request.isEmailVerified) ||
      (searchLower === "not checked" && !request.isEmailVerified)
    );
  });

  // Calculate total pages for users`
  const totalPages = Math.ceil(filteredRequests.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = filteredRequests.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Handle admin verification==========================
  const handleVerifyAdmin = async (adminID) => {
    console.log("Verifying admin with ID:", adminID);
    try {
      setAdminVerifyLoading(true);
      const response = await instance.patch("/api/v1/superadmin/auth/verifyAdmin", {
        AdminID: adminID,
      });
      console.log("Verification response:", response.data);
      if (response.data.success) {
        toast.success("Admin verified successfully");
        setAdmins((prevAdmins) =>
          prevAdmins.map((admin) =>
            admin.AdminID === adminID
              ? { ...admin, adminVerification: "Verified" }
              : admin
          )
        );
        setLastVerifiedAdminID(adminID); // Trigger highlight

      // Remove highlight after 2 seconds
      setTimeout(() => {
        setLastVerifiedAdminID(null);
      }, 2000);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to verify admin");
    } finally {
      setAdminVerifyLoading(false);
    }
  };

  // Handle disapprove admin==========================
  const handleDisapproveAdmin = async (adminID) => {
    console.log("Disapproving admin with ID:", adminID);
    try {
      setAdminVerifyLoading(true);
      const response = await instance.patch("/api/v1/superadmin/auth/disproveadmin", {
        AdminID: adminID,
      });
      console.log("Disapproval response:", response.data);
      if (response.data.success) {
        toast.success("Admin disapproved successfully");
        setAdmins((prevAdmins) =>
          prevAdmins.map((admin) =>
            admin.AdminID === adminID
              ? { ...admin, adminVerification: "Disapproved" }
              : admin
          )
        );
        setLastVerifiedAdminID(adminID); // Trigger highlight

      // Remove highlight after 2 seconds
      setTimeout(() => {
        setLastVerifiedAdminID(null);
      }, 2000);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to disapprove admin");
    } finally {
      setAdminVerifyLoading(false);
    }
  };

  // download CSV function=============
const downloadCSV = () => {
  const headers = [
    "AdminID",
    "FullName",
    "Email",
    "isEmailVerified",
    "Phone",
    "Role",
    "AdminVerification",
    "Admin Status",
    "JoinedDate",
  ];

  const escapeCSV = (value) => {
    if (value === null || value === undefined) return '""';
    const str = value.toString();
    return `"${str.replace(/"/g, '""')}"`; // Escape double quotes, wrap in quotes
  };

  const rows = filteredRequests.map((req) => [
    escapeCSV(req.AdminID),
    escapeCSV(req.FullName),
    escapeCSV(req.Email),
    escapeCSV(req.isEmailVerified ? "Verified" : "Not Checked"),
    escapeCSV(req.Phone),
    escapeCSV(req.Role),
    escapeCSV(req.adminVerification),
    escapeCSV(req.isDeleted ? "Deleted" : "Active"),
    escapeCSV(new Date(req.createdAt).toLocaleDateString()),
  ]);

  const csvContent = [headers.map(escapeCSV), ...rows]
    .map((row) => row.join(","))
    .join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", "All_Admins.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

  return (
    <>
      {deleteLoading && <Loader />}
      {isLoading && <Loader />}
      <div>
        <h2>Admins Management</h2>
        <div className="csv">
          <p style={{ color: "green" }}>
            Total Admins: {filteredRequests.length}
          </p>
          <button
            onClick={downloadCSV}
            className="downloadBtn"
            style={{ alignSelf: "flex-end" }}>
            <TbFileDownload />
          </button>
        </div>
        <div className="scrollable-table">
          <table>
            <thead style={{ fontSize: "0.8rem" }}>
              <tr>
                <th>Joined Date</th>
                <th>Admin ID</th>
                <th>Full Name</th>
                <th>Email</th>
                <th>Email Verified</th>
                <th>Phone</th>
                <th>Total Users Handling</th>
                <th>Role</th>
                <th>Admin Verification</th>
                <th>User Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(currentItems) && currentItems.length > 0 ? (
                currentItems.map((admin) => (
                  <tr key={admin.AccountID} className={admin.AdminID === lastVerifiedAdminID ? "highlight-row" : ""}>
                    <td>{new Date(admin.createdAt).toLocaleDateString()}</td>
                    <td>{admin.AdminID}</td>
                    <td>{admin.FullName}</td>
                    <td>{admin.Email}</td>
                    <td>
                      {admin.isEmailVerified ? (
                        <MdVerifiedUser style={{ color: "green" }} />
                      ) : (
                        <MdDoNotDisturbOn style={{ color: "red" }} />
                      )}
                    </td>
                    <td>{admin.Phone}</td>
                    <td>{admin.totalUsersHandling}</td>
                    <td>{admin.Role}</td>
                    <td>
                      <span
                        style={{
                          color:
                            admin.adminVerification === "Pending" || admin.adminVerification === "Disapproved"
                              ? "red"
                              : "green"
                        }}
                      >
                        {admin.adminVerification}
                      </span>
                    </td>
                    <td>
                      {admin.isDeleted ? (
                        <span style={{ color: "red" }}>
                          <BiSolidUserX /> Deleted
                        </span>
                      ) : (
                        <span style={{ color: "green" }}>
                          <BiSolidUserCheck /> Active
                        </span>
                      )}
                    </td>
                    <td>
                      <button
                        className="deleteBtn"
                        onClick={() => {
                          setSelectedUser(admin); // sets the full user object
                            setShowDeleteModal(true); // show modal
                            }}>
                            Delete
                            </button>
                            {admin.adminVerification === "Verified" ? (
                            <button
                              className="disproveAdminBtn"
                              onClick={() => {
                              setSelectedUser(admin);
                              handleDisapproveAdmin(admin.AdminID);
                              }}>
                              {adminVerifyLoading && selectedUser?.AdminID === admin.AdminID ? (
                              <Spinner animation="border" size="sm" />
                              ) : (
                              "DisapproveAdmin"
                              )}
                            </button>
                            ) : (
                            <button
                              className="verifyAdminBtn"
                              onClick={() => {
                              setSelectedUser(admin); // sets the full admin object
                              handleVerifyAdmin(admin.AdminID);
                              }}>
                              {adminVerifyLoading && selectedUser?.AdminID === admin.AdminID ? (
                              <Spinner animation="border" size="sm" />
                              ) : (
                              "VerifyAdmin"
                              )}
                            </button>
                            )}
                          </td>
                          </tr>
                          ))
                          ) : isLoading ? (
                          <tr>
                          <td colSpan="11">
                          <ShimmerLoader width="100%" height="30px" />
                          </td>
                          </tr>
                          ) : (
                          <tr>
                          <td colSpan="11">No users found</td>
                          </tr>
                          )}
                        </tbody>
                        </table>
                        </div>

                        {/* Pagination */}
        <div className="d-flex justify-content-center mt-3">
          <Pagination>
            {[...Array(totalPages)].map((_, pageIndex) => (
              <Pagination.Item
                key={pageIndex}
                active={currentPage === pageIndex + 1}
                onClick={() => handlePageChange(pageIndex + 1)}>
                {pageIndex + 1}
              </Pagination.Item>
            ))}
          </Pagination>
        </div>
      </div>

        {/* delete confirmation modal */}
            {showDeleteModal && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1000,
                }}>
                <div
                  style={{
                    backgroundColor: "#fff",
                    padding: "20px",
                    borderRadius: "8px",
                    textAlign: "center",
                    minWidth: "300px",
                  }}>
                  <MdDelete style={{ color: "red", fontSize: "5rem" }} />
                  <h5>Are you sure you want to delete this user?</h5>
                  <div
                    style={{
                      marginTop: "1rem",
                      display: "flex",
                      justifyContent: "space-around",
                    }}>
                    <button
                      style={{
                        backgroundColor: "red",
                        color: "white",
                        padding: "6px 12px",
                        border: "none",
                        borderRadius: "4px",
                      }}
                      onClick={async () => {
                        if (selectedUser && selectedUser.AdminID) {
                          try {
                            setDeleteLoading(true);
                            await deleteAdmin(selectedUser.AdminID);
                            toast.success("admin deleted successfully");
      
                            // Optionally refresh the users list
                            setAdmins((prev) =>
                              prev.map((u) =>
                                u.AdminID === selectedUser.AdminID
                                  ? { ...u, isDeleted: true }
                                  : u
                              )
                            );
                          } catch (error) {
                            toast.error("Failed to delete admin");
                            console.error("Delete error:", error);
                          } finally {
                            setDeleteLoading(false);
                          }
                        }
                        setShowDeleteModal(false);
                        setSelectedUser(null);
                      }}>
                      Yes
                    </button>
      
                    <button
                      style={{
                        backgroundColor: "gray",
                        color: "white",
                        padding: "6px 12px",
                        border: "none",
                        borderRadius: "4px",
                      }}
                      onClick={() => {
                        setShowDeleteModal(false);
                        setSelectedUser(null); // reset
                      }}>
                      No
                    </button>
                  </div>
                </div>
              </div>
            )}
    </>
  );
};

export default AllAdmins;
